{
	"locale": "en",
	"services": [
		{
			"id": "liion",
			"slug": "lithium-ion-battery-recycling",
			"name": "Lithium-ion battery recycling",
			"short": "Controlled discharge, processing and recovery of lithium, cobalt and nickel.",
			"desc": "Safe intake, discharge and processing of lithium-ion cells and packs — from power tools to traction packs and energy-storage systems.",
			"stat": "96%",
			"statLabel": "material recovery rate in the battery stream",
			"spec": [
				"Controlled destruction under safe conditions",
				"Dry and wet discharge",
				"Categorisation and sorting by cell chemistry (NMC, LFP, other)",
				"Separation into material fractions",
				"Qualification of cells for re-use",
				"Recovery documentation and recycling certificates"
			],
			"groups": [
				"Batteries from portable devices",
				"Power-tool packs",
				"Traction packs from forklifts",
				"Batteries from e-scooters and e-bikes",
				"Packs from EV and hybrid vehicles",
				"Batteries from UPS and energy storage",
				"Production waste and quality rejects",
				"Damaged and critical batteries",
				"MIX sorting"
			]
		},
		{
			"id": "pb",
			"slug": "lead-acid-battery-recycling",
			"name": "Lead-acid battery recycling",
			"short": "Starter, traction and stationary batteries.",
			"desc": "Intake and processing of lead-acid batteries from the automotive and industrial markets, including full documentation handling.",
			"stat": "100%",
			"statLabel": "of the stream covered by records and documentation",
			"spec": [
				"Processing and regeneration of lead-acid batteries",
				"Safe collection and specialist transport",
				"Mass records and transfer documentation",
				"Settlement with competitive payment options"
			],
			"groups": [
				"Automotive (starter) batteries",
				"Traction batteries",
				"Stationary batteries",
				"Industrial batteries"
			]
		},
		{
			"id": "sort",
			"slug": "textile-sorting",
			"name": "Textile sorting",
			"short": "Sort zero, quality sorting and product sorting.",
			"desc": "Intake, weighing and sorting of the textile stream into commercial fractions matched to the requirements of the target markets.",
			"stat": "A–D",
			"statLabel": "quality fractions plus wipers and residue",
			"spec": [
				"Intake, weighing and stream records",
				"Sort zero — separating the base fractions",
				"Quality and product sorting",
				"Preparing goods for wholesale, export or wipers",
				"Mass and yield reporting"
			],
			"groups": [
				"Women's, men's and children's clothing",
				"Footwear and accessories",
				"Home textiles",
				"Toys and extras",
				"Fractions A, B, C, D",
				"Industrial wipers",
				"Residue"
			]
		},
		{
			"id": "hurt",
			"slug": "textile-commercial-fractions-wholesale",
			"name": "Commercial fractions and wholesale in Poland",
			"short": "Commercial lots for wholesalers and second-hand chains.",
			"desc": "Preparation and sale of commercial lots matched to the buyer's channel — with price lists, mixes and steady availability.",
			"stat": "PL",
			"statLabel": "nationwide network of wholesale buyers",
			"spec": [
				"Building price lists, packs and mixes",
				"Matching goods quality to the sales channel",
				"Coordinating availability with the sorting plant and warehouse",
				"Handling enquiries and sales terms"
			],
			"groups": [
				"Second-hand clothing wholesalers",
				"Second-hand shops",
				"Fraction B and outlet",
				"Seasonal mix",
				"Footwear and accessories",
				"Technical fractions"
			]
		},
		{
			"id": "eksport",
			"slug": "textile-container-export",
			"name": "Container export of textiles",
			"short": "Container, pallet and baled mixes for external markets.",
			"desc": "Preparation of export fractions and full coordination of loadings, documents and payments.",
			"stat": "3 markets",
			"statLabel": "Africa, the Middle East, Latin America",
			"spec": [
				"Preparing export fractions C and D",
				"Building container and baled mixes",
				"Coordinating quality, quantity and documents",
				"Working with carriers and freight forwarders",
				"Export customs clearance"
			],
			"groups": [
				"Clothing mix",
				"Footwear",
				"Accessories",
				"Baled fractions",
				"Seasonal and winter collections"
			]
		},
		{
			"id": "czysciwo",
			"slug": "industrial-wipers-technical-fractions",
			"name": "Industrial wipers and technical fractions",
			"short": "Textiles redirected to industrial applications.",
			"desc": "Separating and preparing textiles suitable for industrial wipers — instead of disposal.",
			"stat": "0 waste",
			"statLabel": "goal: minimising the residue fraction",
			"spec": [
				"Separating textiles destined for wipers",
				"Splitting by composition, colour and usability",
				"Baling, cutting and packing",
				"Sales to plants and service companies"
			],
			"groups": [
				"Light cotton",
				"Coloured cotton",
				"Knitwear and T-shirts",
				"Bed linen",
				"Industrial fractions"
			]
		},
		{
			"id": "pszok",
			"slug": "textiles-from-municipal-collection",
			"name": "Streams from municipal collection points and drives",
			"short": "An intake and sorting model for municipal textiles.",
			"desc": "Operational support for municipalities meeting the separate textile collection obligation, including a recommended handling model.",
			"stat": "2025",
			"statLabel": "separate textile collection becomes mandatory",
			"spec": [
				"Support for the intake and sorting model at collection points",
				"Stream quality assessment and model recommendation",
				"Preparing the stream for onward handling",
				"Reporting masses and destinations"
			],
			"groups": [
				"Municipal collection points",
				"Door-to-door drives",
				"Local and school campaigns",
				"Workplaces",
				"Courier channels"
			]
		},
		{
			"id": "premium",
			"slug": "premium-selection-for-re-commerce",
			"name": "Premium selection for re-commerce",
			"short": "Separating goods with a higher unit value.",
			"desc": "Identifying and preparing branded clothing and accessories for unit sales in online channels.",
			"stat": "1:1",
			"statLabel": "unit classification: brand, condition, season",
			"spec": [
				"Separating higher-value items",
				"Assessing suitability for online sale",
				"Classification: brand, condition, season, category",
				"Hand-off to the e-commerce channel"
			],
			"groups": [
				"Branded and premium clothing",
				"Shoes and handbags",
				"Accessories",
				"Seasonal collections",
				"New and outlet goods"
			]
		},
		{
			"id": "zsee",
			"slug": "weee-recycling-appliances",
			"name": "WEEE recycling — large and small appliances",
			"short": "The full stream of waste electrical and electronic equipment.",
			"desc": "Processing of waste electrical and electronic equipment in line with the WEEE act — from refrigeration to small appliances and office equipment.",
			"stat": "6 groups",
			"statLabel": "equipment categories covered by processing",
			"spec": [
				"Controlled destruction and processing",
				"Dismantling and separation of material fractions",
				"Removal of batteries and hazardous components",
				"Handling of both complete and incomplete equipment",
				"Waste records and transfer notes"
			],
			"groups": [
				"Refrigeration equipment",
				"Washing machines, dryers and dishwashers",
				"Kitchen equipment and ovens",
				"Air conditioning and ventilation",
				"Small appliances",
				"Office equipment",
				"Telecommunications equipment",
				"Light sources"
			]
		},
		{
			"id": "chlod",
			"slug": "refrigeration-and-heat-pump-recycling",
			"name": "Refrigeration and heat-pump recycling",
			"short": "Fridges, display cabinets, freezers, air conditioning, heat pumps.",
			"desc": "Specialist processing of refrigeration equipment with safe recovery of refrigerants and material fractions.",
			"stat": "Z3",
			"statLabel": "refrigeration processing plants in the group",
			"spec": [
				"Controlled destruction and processing",
				"Refrigerant recovery",
				"Separation of plastics, metals and foams",
				"Handling of commercial and industrial equipment"
			],
			"groups": [
				"Domestic fridges",
				"Display cabinets and chilled counters",
				"Refrigerated cabinets",
				"Freezers",
				"Air conditioners",
				"Heat pumps",
				"Boilers and heat exchangers",
				"Vending machines",
				"Sandwich panels"
			]
		},
		{
			"id": "pcb",
			"slug": "electronics-and-pcb-recycling",
			"name": "Electronics and PCB recycling",
			"short": "Printed circuit boards, laminates, IT and server hardware.",
			"desc": "Recovery of precious metals and technical fractions from printed circuit boards and complete IT devices.",
			"stat": "24 h",
			"statLabel": "response time to a collection request",
			"spec": [
				"Controlled destruction and processing",
				"Specialist transport",
				"Categorisation of laminates and fractions",
				"A dedicated manager and fast settlement"
			],
			"groups": [
				"Printed circuit boards",
				"Copper and gold laminates",
				"Hard drives and optical drives",
				"Power supplies",
				"Laptops and desktop PCs",
				"Servers",
				"Routers and switches",
				"Tablets and phones"
			]
		},
		{
			"id": "pv",
			"slug": "pv-panel-and-inverter-recycling",
			"name": "PV panel and inverter recycling",
			"short": "Photovoltaic panels, converters, ancillary equipment.",
			"desc": "Handling of end-of-life and damaged photovoltaic installations together with their ancillary equipment.",
			"stat": "RES",
			"statLabel": "environmental obligations for renewables",
			"spec": [
				"Controlled destruction and processing",
				"Dismantling and collection of installations",
				"Separation of glass, frames and components",
				"Documentation for producers placing goods on the market"
			],
			"groups": [
				"Photovoltaic panels",
				"Hybrid panels and collectors",
				"Inverters and converters",
				"Cables, racks and ancillary equipment"
			]
		},
		{
			"id": "toner",
			"slug": "toner-and-cartridge-recycling",
			"name": "Toner and cartridge recycling",
			"short": "Cassettes, tubes, cartridges, toner powder.",
			"desc": "Processing of toner waste from the office and industrial sectors — safely and with full documentation.",
			"stat": "B2B",
			"statLabel": "serving office networks and service points",
			"spec": [
				"Controlled destruction and processing",
				"Collection from multiple client locations",
				"Records and statutory reporting",
				"Mass reporting for the client"
			],
			"groups": ["Toner cassettes", "Toner tubes", "Cartridges", "Toner powder"]
		},
		{
			"id": "inne",
			"slug": "tyres-furniture-other-fractions",
			"name": "Tyres, furniture and other fractions",
			"short": "Non-standard and mixed streams.",
			"desc": "Handling of waste outside the main streams — furniture, tyres and mixed fractions from production plants and retail.",
			"stat": "MIX",
			"statLabel": "handling of mixed and non-standard streams",
			"spec": [
				"Processing and regeneration",
				"Collection of industrial volumes",
				"Stream assessment and a recommended handling route",
				"Design solutions from secondary raw materials"
			],
			"groups": [
				"Carcass and household furniture",
				"Office furniture",
				"Specialist furniture",
				"Garden furniture",
				"Passenger and truck tyres",
				"Agricultural machinery tyres",
				"Other waste"
			]
		},
		{
			"id": "refurb",
			"slug": "reuse-and-refurbishment",
			"name": "RE-USE and refurbishment",
			"short": "Testing, diagnostics, regeneration and cosmetic refurbishment.",
			"desc": "Multi-stage functional verification, repair and cosmetic-technical refurbishment of second-life devices before they re-enter the market.",
			"stat": "Grade A–D",
			"statLabel": "standardised quality classification",
			"spec": [
				"Testing, technical diagnostics and functional verification",
				"Regeneration, cleaning and repair",
				"Cosmetic and technical refurbishment",
				"Accessory kitting and safe packing",
				"Certification of technical condition"
			],
			"groups": [
				"Large free-standing and built-in appliances",
				"Small kitchen appliances",
				"Home and garment-care appliances",
				"Seasonal and climate appliances",
				"Power tools and garden equipment",
				"TV and audio",
				"Consumer electronics, IT and mobile",
				"Personal care"
			]
		},
		{
			"id": "grading",
			"slug": "grading-and-condition-certification",
			"name": "Grading and condition certification",
			"short": "Standardised assessment of technical and cosmetic condition.",
			"desc": "A single quality classification system that tells the buyer exactly what they get — from Grade A down to spare parts.",
			"stat": "5 grades",
			"statLabel": "quality levels in the group's standard",
			"spec": [
				"Standardised assessment of technical and functional condition",
				"Grades A / B / C / D / Outlet",
				"Completeness verification",
				"Condition certificate and product card",
				"Custom grading to the buyer's specification"
			],
			"groups": [
				"Tested/working equipment",
				"Untested complete equipment",
				"Incomplete equipment / for parts",
				"Ex-display goods",
				"Consumer returns"
			]
		},
		{
			"id": "depak",
			"slug": "pack-disassembly-and-cell-recovery",
			"name": "Pack disassembly and cell recovery",
			"short": "Pack teardown, measurement and cell packaging.",
			"desc": "Recovery of healthy cells from battery packs and preparing them for a second life in energy storage and industrial applications.",
			"stat": "4 types",
			"statLabel": "cylindrical, prismatic and pouch cells, and modules",
			"spec": [
				"Disassembly of battery packs",
				"Cell parameter measurement",
				"Sorting and packaging",
				"Qualification for re-use",
				"Sales of cells to domestic and foreign buyers"
			],
			"groups": [
				"Cylindrical cells",
				"Prismatic cells",
				"Pouch cells",
				"Battery modules",
				"Material fractions"
			]
		},
		{
			"id": "data",
			"slug": "certified-data-erasure",
			"name": "Certified data erasure",
			"short": "Irreversible erasure of media with a report.",
			"desc": "A service for companies reselling IT hardware — a certificate of permanent data erasure compliant with GDPR and ISO 27001.",
			"stat": "GDPR",
			"statLabel": "compliant with GDPR and ISO 27001",
			"spec": [
				"Irreversible erasure of storage media",
				"A certificate and report for every device",
				"Handling of corporate fleets",
				"Optional physical destruction of the medium"
			],
			"groups": [
				"Laptops and computers",
				"Hard drives and SSDs",
				"Smartphones and tablets",
				"Servers and storage arrays",
				"Removable media"
			]
		},
		{
			"id": "omni",
			"slug": "multichannel-d2c-and-b2b-sales",
			"name": "Multichannel D2C and B2B sales",
			"short": "Own store, marketplaces, pallet and stock-lot wholesale.",
			"desc": "Commercialisation of RE-USE goods in retail and wholesale channels, including returns and complaint handling.",
			"stat": "4 channels",
			"statLabel": "own store, marketplace, wholesale, export",
			"spec": [
				"D2C retail: own store and marketplace platforms",
				"B2B wholesale: pallets, packs, stock lots",
				"Reverse-logistics management",
				"Handling complaints and consumer returns",
				"Value-added services: extended warranty, delivery with carry-in"
			],
			"groups": [
				"RE-USE and refurbished equipment",
				"Warehouse surplus",
				"Consumer returns",
				"Ex-display goods",
				"Boxed stock lots",
				"Books and media",
				"Parts and components"
			]
		},
		{
			"id": "asset",
			"slug": "asset-recovery-and-wholesale",
			"name": "Asset recovery and wholesale",
			"short": "Container and pallet volumes for the Polish and export markets.",
			"desc": "Value recovery from surplus, returns and end-of-line stock in a wholesale model — with full customs and export handling.",
			"stat": "20/40 ft",
			"statLabel": "container volumes and pallet wholesale",
			"spec": [
				"Quality qualification and material/commercial categorisation",
				"End-to-end B2B service for Poland and foreign markets",
				"Arranging customs clearance and export documentation",
				"International logistics and loading coordination",
				"Commercial negotiations"
			],
			"groups": [
				"Wholesale TV/appliance stock lots",
				"Pallets of consumer returns",
				"B2B containers",
				"Textiles and second-hand clothing",
				"Power tools and industrial equipment",
				"PV panels and ancillary equipment",
				"Tyres",
				"Books, toners and cartridges"
			]
		},
		{
			"id": "kaucja",
			"slug": "deposit-scheme-producer-services",
			"name": "Producer services in the deposit-return scheme",
			"short": "Onboarding, contracts, settlement models and reporting.",
			"desc": "End-to-end preparation of a beverage producer for deposit-return obligations — from SKU analysis to day-to-day operations and settlement.",
			"stat": "2025",
			"statLabel": "the deposit scheme has run since 1 October 2025",
			"spec": [
				"Onboarding the producer into the scheme",
				"Analysis of volumes, SKU count and sales structure",
				"Financial models: operator fee, deposit, handling fee",
				"Coordination across commercial, legal and operations teams",
				"Reporting and business reviews"
			],
			"groups": [
				"Single-use PET bottles",
				"Metal cans (aluminium, steel)",
				"Refillable glass bottles",
				"Beverage producer SKUs",
				"Distributors and importers"
			]
		},
		{
			"id": "rop",
			"slug": "epr-batteries-textiles-renewables",
			"name": "EPR: batteries, textiles, renewables",
			"short": "Handling extended producer responsibility.",
			"desc": "Delivering extended-producer-responsibility obligations per product category — with the right route and scheme selected for you.",
			"stat": "3 streams",
			"statLabel": "batteries · textiles · renewables and electronics",
			"spec": [
				"Analysis of EPR obligations for the product category",
				"Selection of a dedicated handling scheme",
				"Implementation of collection, recovery and reporting processes",
				"Ongoing operations and cost optimisation",
				"Keeping compliance current with the law"
			],
			"groups": [
				"Batteries and accumulators",
				"Textiles",
				"Electrical and electronic equipment",
				"PV panels and renewables",
				"Packaging"
			]
		},
		{
			"id": "bdo",
			"slug": "waste-records-and-reporting",
			"name": "Waste records and statutory reporting",
			"short": "Oversight of a plant's records and statutory reporting.",
			"desc": "Keeping and supervising waste records in the national register plus support with periodic statutory reporting.",
			"stat": "Records",
			"statLabel": "complete records and statutory reporting",
			"spec": [
				"Oversight of the plant's waste-management process",
				"Keeping records in the national waste register",
				"Issuing and confirming waste transfer notes",
				"Preparing periodic statutory reports",
				"Identifying data gaps and risks"
			],
			"groups": [
				"Production plants",
				"Retail chains",
				"Public institutions",
				"Logistics operators",
				"Producers placing goods on the market"
			]
		},
		{
			"id": "dok",
			"slug": "recovery-documentation-and-certificates",
			"name": "Recovery documentation and certificates",
			"short": "Transfer notes, recycling certificates, mass statements.",
			"desc": "A complete set of documents confirming correct transfer and processing of waste — ready to use in your own statutory reporting.",
			"stat": "100%",
			"statLabel": "of enquiries with full recovery documentation",
			"spec": [
				"Issuing and confirming waste transfer notes",
				"Recycling certificates",
				"Annual statements of collected and processed masses",
				"Documentation for audits and tenders"
			],
			"groups": [
				"Waste transfer notes",
				"Recycling certificates",
				"Annual statements",
				"Audit reports",
				"Tender documentation"
			]
		},
		{
			"id": "srodowisko",
			"slug": "environmental-advisory-and-permits",
			"name": "Environmental advisory and permits",
			"short": "Permits, compliance, environmental accounting.",
			"desc": "Support in obtaining permits, running environmental accounting and keeping compliance with the law.",
			"stat": "Compliance",
			"statLabel": "from the permit to day-to-day compliance",
			"spec": [
				"Environmental protection advisory",
				"Obtaining operating permits",
				"Environmental accounting and reporting",
				"Compliance with environmental law",
				"Waste-management audit at the client's site"
			],
			"groups": [
				"Processing plants",
				"Producers and importers",
				"Logistics operators",
				"Municipalities",
				"SMEs in the value chain"
			]
		},
		{
			"id": "adr",
			"slug": "adr-collection-and-transport",
			"name": "ADR collection and transport",
			"short": "Scheduled, one-off and emergency battery collections.",
			"desc": "Safe transport of hazardous waste — including damaged and critical lithium-ion batteries — with our own specialist fleet.",
			"stat": "ADR",
			"statLabel": "own fleet and safe certified containers",
			"spec": [
				"Collection by ADR transport",
				"Scheduled collections on a fixed timetable",
				"One-off and emergency collections",
				"Route consolidation for multi-site clients",
				"Collection of damaged batteries after condition assessment"
			],
			"groups": [
				"End-of-life batteries",
				"Damaged and critical batteries",
				"Whole automotive batteries",
				"Production waste",
				"Traction packs",
				"The WEEE stream"
			]
		},
		{
			"id": "pojemniki",
			"slug": "li-ion-container-leasing",
			"name": "Li-ion container leasing",
			"short": "Four container lines: OFFICE, CHARGE, TRANS-STORE, RESCUE.",
			"desc": "Selection, delivery and rotation of containers for safe storage and charging of lithium-ion batteries — on a leasing model.",
			"stat": "4 lines",
			"statLabel": "OFFICE · CHARGE · TRANS-STORE · RESCUE",
			"spec": [
				"Matching the container to volume and waste type",
				"Leasing with container rotation at collection",
				"Safe charging inside an isolated container",
				"Uniform identification and fleet records",
				"Leasing only — no purchase model"
			],
			"groups": [
				"Office containers (OFFICE)",
				"Charging containers (CHARGE)",
				"Workstation containers (TRANS-STORE)",
				"Warehouse containers",
				"Industrial and hub containers",
				"Containers for damaged batteries (RESCUE)"
			]
		},
		{
			"id": "siec",
			"slug": "container-networks-and-collection-points",
			"name": "Container networks and collection points",
			"short": "A nationwide network for e-waste and battery collection.",
			"desc": "Designing and maintaining collection-point networks for companies, retail chains, municipalities and schools.",
			"stat": "PL",
			"statLabel": "nationwide network of red collection bins",
			"spec": [
				"Designing local collection systems",
				"Container installation and servicing",
				"Mobile and fixed collection points",
				"Handling requests and interventions",
				"Reporting outcomes and indicators"
			],
			"groups": [
				"Red bins for e-waste",
				"Battery bins",
				"Points at fire-service units",
				"Points in shopping centres",
				"School and office drives",
				"Mobile city collections"
			]
		},
		{
			"id": "zwrotna",
			"slug": "reverse-logistics-and-home-collection",
			"name": "Reverse logistics and home collection",
			"short": "B2C, B2B and bulky collections from the client's location.",
			"desc": "Full organisation of waste-equipment collections — from the online request through carry-out to the documentation.",
			"stat": "24/7",
			"statLabel": "collection requests via the online form",
			"spec": [
				"Accepting equipment collection orders",
				"Bulky collection from a resident's home",
				"Carry-out from an indicated location",
				"Coordinating dates with logistics and carriers",
				"After-sales support: reports, settlements, complaints"
			],
			"groups": [
				"Households",
				"Companies and enterprises",
				"Public institutions",
				"Local government units",
				"Schools and educational facilities",
				"Housing cooperatives and associations"
			]
		},
		{
			"id": "zwrotomat",
			"slug": "return-points-and-reverse-vending",
			"name": "Return points and reverse vending machines",
			"short": "Deposit packaging return machines for municipalities and retail.",
			"desc": "Installation and operation of deposit packaging return points — at public offices, transport hubs and car parks.",
			"stat": "Deposit",
			"statLabel": "automated deposit settlement with the operator",
			"spec": [
				"Installing reverse vending machines on municipal sites and in retail",
				"Automated deposit settlement",
				"Passing data to the scheme operator",
				"Collection of gathered packaging",
				"Fill-level monitoring of the machines"
			],
			"groups": [
				"PET bottles",
				"Metal cans",
				"Refillable glass bottles",
				"Points at public offices",
				"Transport hubs and Park & Ride"
			]
		},
		{
			"id": "bpo",
			"slug": "operational-and-technology-bpo",
			"name": "Operational and technology BPO",
			"short": "Outsourced operations: customer service, logistics, sorting, settlement.",
			"desc": "Taking over and running the entire packaging or waste loop — from the first mile to settlement and analytics.",
			"stat": "End-to-end",
			"statLabel": "from the first mile to settlement",
			"spec": [
				"First- and second-mile logistics management",
				"Sourcing and managing consolidation points",
				"Sorting plants and counting centres",
				"Integrations with subcontractors and recyclers",
				"Settlement, records and data analytics"
			],
			"groups": [
				"Deposit-return scheme",
				"EPR — textiles",
				"EPR — batteries",
				"Collection points",
				"Scanners and reverse vending machines",
				"Bags and seals"
			]
		},
		{
			"id": "analiza",
			"slug": "esg-analysis-and-strategy",
			"name": "ESG analysis and strategy",
			"short": "Business-model audit, double materiality, stakeholder map.",
			"desc": "Eight steps from the workshop and data gathering to a double-materiality analysis and EU Taxonomy alignment.",
			"stat": "8 steps",
			"statLabel": "a standardised ESG analysis process",
			"spec": [
				"Workshop and training session with recommendations",
				"Gathering and verifying E, S and G data",
				"Business-model audit with a gap analysis",
				"Double-materiality analysis",
				"Stakeholder map and communication plan",
				"EU Taxonomy alignment analysis"
			],
			"groups": [
				"Large enterprises",
				"SMEs in the value chain",
				"Capital groups",
				"Tender participants",
				"Local government units"
			]
		},
		{
			"id": "raport",
			"slug": "esg-report-csrd-esrs",
			"name": "ESG report under CSRD/ESRS",
			"short": "A full non-financial report compliant with European standards.",
			"desc": "A sustainability report built on ESRS and sector guidance, prepared with later assurance in mind.",
			"stat": "ESRS",
			"statLabel": "full scope E1–E5, S1–S4, G1",
			"spec": [
				"A full non-financial report under ESRS",
				"Rigorous analysis of data and metrics",
				"Support in meeting the legal obligation",
				"Preparing input for value-chain reports",
				"Building credibility with investors"
			],
			"groups": [
				"ESRS 1–2 — general requirements",
				"E1 Climate change",
				"E2 Pollution",
				"E3 Water",
				"E4 Biodiversity",
				"E5 Circular economy",
				"S1–S4 Social topics",
				"G1 Governance"
			]
		},
		{
			"id": "slad",
			"slug": "carbon-footprint-scope-1-2-3",
			"name": "Carbon footprint — Scope 1, 2 and 3",
			"short": "Calculation of direct and indirect emissions.",
			"desc": "Calculating the organisation's carbon footprint across all three scopes together with decarbonisation recommendations.",
			"stat": "Scope 1–3",
			"statLabel": "the organisation's full emissions scope",
			"spec": [
				"Scope 1 — direct emissions",
				"Scope 2 — indirect energy emissions",
				"Scope 3 — value-chain emissions",
				"Decarbonisation policy",
				"Preparing the data for the report"
			],
			"groups": [
				"Process emissions",
				"Electricity and heat",
				"Purchased goods and services",
				"Transport and logistics",
				"Product use",
				"Waste handling"
			]
		},
		{
			"id": "szkolenia",
			"slug": "esg-training-and-workshops",
			"name": "ESG training and workshops",
			"short": "Introductory programmes and dedicated sessions per ESRS topic.",
			"desc": "Training for management and operating teams — from CSRD basics to a detailed walk-through of the standards.",
			"stat": "20+",
			"statLabel": "training topics in the catalogue",
			"spec": [
				"Introductory ESG and CSRD training",
				"Training for reporting entities",
				"Dedicated training per ESRS topic",
				"Workshops on gap and double-materiality analysis",
				"Greenwashing and whistleblower protection"
			],
			"groups": [
				"Management",
				"Finance and compliance teams",
				"Operating teams",
				"Procurement teams",
				"Local government units"
			]
		},
		{
			"id": "city",
			"slug": "esg-city-municipalities",
			"name": "ESG City — cities and municipalities",
			"short": "Advisory, reporting and municipal programmes.",
			"desc": "Implementing sustainability principles in local government units, together with collection and education programmes.",
			"stat": "Smart City",
			"statLabel": "data analytics and circular-economy indicators",
			"spec": [
				"ESG advisory and reporting for cities and municipalities",
				"Collection programmes and inter-city competitions",
				"Collection data analysis and device monitoring",
				"Integration with municipal IT systems",
				"Reporting of recycling indicators"
			],
			"groups": [
				"City and municipal offices",
				"Inter-municipal associations",
				"Municipal collection points",
				"Municipal companies",
				"Educational facilities"
			]
		},
		{
			"id": "edu",
			"slug": "environmental-education-and-csr-campaigns",
			"name": "Environmental education and CSR campaigns",
			"short": "School programmes, public campaigns, charity collection drives.",
			"desc": "Designing and running activities that engage employees, customers and local communities around a real environmental outcome.",
			"stat": "Outcome",
			"statLabel": "we measure behaviour change, not just reach",
			"spec": [
				"CSR campaigns engaging employees and customers",
				"Workshops, picnics and environmental events",
				"Education programmes for schools and kindergartens",
				"Drives combining an environmental and a charitable goal",
				"Measuring the behavioural effect of the activity"
			],
			"groups": [
				"Schools and kindergartens",
				"Universities",
				"Shopping centres",
				"Companies and workplaces",
				"Fire-service units",
				"Non-governmental organisations"
			]
		},
		{
			"id": "bok",
			"slug": "customer-service-and-environmental-helpline",
			"name": "Customer service and environmental helpline",
			"short": "Handling requests by phone, e-mail and online form.",
			"desc": "End-to-end customer service across B2B and B2C channels, compliant with the WEEE act and waste-register requirements.",
			"stat": "B2B + B2C",
			"statLabel": "one service desk for both channels",
			"spec": [
				"Helpline and multichannel request handling",
				"Accepting collection orders",
				"Support in preparing waste for collection",
				"Coordinating dates with logistics",
				"Reporting results and analysing effectiveness"
			],
			"groups": [
				"Phone requests",
				"E-mail requests",
				"Online form",
				"Container interventions",
				"Complaints and settlements"
			]
		}
	],
	"categories": [
		{
			"id": "bat",
			"num": "01",
			"slug": "battery-recycling",
			"title": "Battery recycling",
			"summary": "Safe intake, discharge and processing of lithium-ion cells and lead-acid batteries — from power tools to traction packs and energy storage.",
			"serviceIds": ["liion", "pb"]
		},
		{
			"id": "txt",
			"num": "02",
			"slug": "textile-recycling",
			"title": "Textile recycling",
			"summary": "Sorting, commercialisation and handling of the textile stream — from municipal collection points and drives to container export and industrial wipers.",
			"serviceIds": ["sort", "hurt", "eksport", "czysciwo", "pszok", "premium"]
		},
		{
			"id": "weee",
			"num": "03",
			"slug": "waste-electronic-equipment",
			"title": "Waste electrical and electronic equipment (WEEE)",
			"summary": "Processing of the full WEEE stream in line with the act — large and small appliances, refrigeration, electronics, PV panels and other fractions.",
			"serviceIds": ["zsee", "chlod", "pcb", "pv", "toner", "inne"]
		},
		{
			"id": "reuse",
			"num": "04",
			"slug": "reuse-and-product-life-extension",
			"title": "RE-USE and product life extension",
			"summary": "Extending product life instead of recycling: testing, regeneration, standardised grading, cell recovery and certified data erasure.",
			"serviceIds": ["refurb", "grading", "depak", "data"]
		},
		{
			"id": "recom",
			"num": "05",
			"slug": "re-commerce",
			"title": "RE-COMMERCE",
			"summary": "Commercialisation of second-life goods: D2C and B2B sales, pallet and container wholesale, and asset recovery on domestic and export markets.",
			"serviceIds": ["omni", "asset"]
		},
		{
			"id": "kauc",
			"num": "06",
			"slug": "deposit-scheme-and-epr",
			"title": "Deposit-return scheme and EPR",
			"summary": "Regulatory obligations for producers — deposit-scheme services, EPR for batteries, textiles and renewables, waste records and recovery documentation.",
			"serviceIds": ["kaucja", "rop", "bdo", "dok", "srodowisko"]
		},
		{
			"id": "log",
			"num": "07",
			"slug": "reverse-logistics",
			"title": "Reverse logistics",
			"summary": "The physical layer of the loop: ADR collections, Li-ion container leasing, collection-point networks, reverse vending and outsourced operations.",
			"serviceIds": ["adr", "pojemniki", "siec", "zwrotna", "zwrotomat", "bpo"]
		},
		{
			"id": "esg",
			"num": "08",
			"slug": "esg-advisory-and-reporting",
			"title": "ESG advisory and reporting",
			"summary": "The strategic layer: ESG analysis and strategy, CSRD/ESRS reporting, carbon footprint, training, municipal programmes, education and customer service.",
			"serviceIds": ["analiza", "raport", "slad", "szkolenia", "city", "edu", "bok"]
		}
	],
	"industries": [
		{
			"name": "Electronics and appliance manufacturers",
			"desc": "EPR, recovery, consumer returns and reporting in one chain.",
			"tag": "WEEE · EPR · RE-USE"
		},
		{
			"name": "Automotive and e-mobility",
			"desc": "Traction batteries, EV packs, ADR transport and second-life cells.",
			"tag": "Batteries · ADR"
		},
		{
			"name": "Retail and store chains",
			"desc": "Returns, stock lots, collection points and deposit-scheme services.",
			"tag": "Deposit · RE-USE"
		},
		{
			"name": "Beverage producers",
			"desc": "Full producer services in the deposit-return scheme.",
			"tag": "Deposit scheme"
		},
		{
			"name": "Fashion and textiles",
			"desc": "Collection, sorting, commercial fractions and EPR duties for textiles.",
			"tag": "Textiles · EPR"
		},
		{
			"name": "Municipalities and cities",
			"desc": "Collection systems, reverse vending, education and circular indicators.",
			"tag": "Smart City · ESG"
		},
		{
			"name": "Industry and logistics",
			"desc": "Production waste, traction batteries, records and permits.",
			"tag": "Records · ADR"
		},
		{
			"name": "Energy and renewables",
			"desc": "PV panels, inverters, energy storage and environmental obligations.",
			"tag": "Renewables · Recycling"
		}
	],
	"cases": [
		{
			"slug": "safe-battery-collection-across-40-sites",
			"tag": "Li-ion batteries",
			"title": "A safe battery collection system across 40 sites",
			"challenge": "A power-tool manufacturer stored spent Li-ion packs at 40 service points with no uniform procedures — a real fire risk and no records.",
			"solution": "An audit, a storage-area design, leased containers and scheduled ADR collections coordinated on a single timetable.",
			"outcome": "After 12 months: zero fire incidents, complete mass records and one account manager for every site.",
			"stat": "0",
			"statLabel": "fire incidents after rollout",
			"photo": "p8",
			"serviceIds": ["liion", "adr", "pojemniki"]
		},
		{
			"slug": "textile-stream-for-a-municipal-association",
			"tag": "Textiles",
			"title": "Handling the textile stream for an association of municipalities",
			"challenge": "Twelve municipalities had to launch separate textile collection with no sorting facility of their own and no settlement model.",
			"solution": "An intake model from municipal collection points, sorting into commercial fractions and monthly mass reporting per municipality.",
			"outcome": "A stream of 1,400 tonnes a year handled and split into commercial fractions, wipers and residue.",
			"stat": "1,400 t",
			"statLabel": "of stream per year",
			"photo": "p6",
			"serviceIds": ["sort", "pszok", "hurt"]
		},
		{
			"slug": "second-life-for-a-retail-chains-returns",
			"tag": "RE-USE",
			"title": "A second life for a retail chain's consumer returns",
			"challenge": "Pallets of returned appliances were going to disposal even though most of the equipment was fully functional.",
			"solution": "Grading, refurbishment and multichannel sales — with a condition certificate for every device.",
			"outcome": "68% of the goods returned to market through D2C and B2B channels instead of being recycled.",
			"stat": "68%",
			"statLabel": "of goods returned to market",
			"photo": "p7",
			"serviceIds": ["refurb", "grading", "omni"]
		},
		{
			"slug": "onboarding-a-beverage-producer-to-the-deposit-scheme",
			"tag": "Deposit scheme",
			"title": "Onboarding a beverage producer to the deposit-return scheme",
			"challenge": "A producer with 340 SKUs had to enter the deposit scheme with no ready data structure and no settlement model.",
			"solution": "SKU analysis, a settlement model, data integration with the operator and the launch of periodic reporting.",
			"outcome": "All 340 SKUs covered by the scheme, with reporting running on a monthly cycle.",
			"stat": "340",
			"statLabel": "SKUs covered by the scheme",
			"photo": "p5",
			"serviceIds": ["kaucja", "rop"]
		},
		{
			"slug": "first-csrd-report-for-a-manufacturing-group",
			"tag": "ESG",
			"title": "The first CSRD report for a manufacturing group",
			"challenge": "A manufacturing group faced its first mandatory ESRS report with no E, S or G data collected.",
			"solution": "A double-materiality analysis, a three-scope carbon footprint and a report prepared for future assurance.",
			"outcome": "The report was filed on time with the full Scope 1–3 emissions range documented.",
			"stat": "Scope 1–3",
			"statLabel": "full emissions scope",
			"photo": "rozmowy",
			"serviceIds": ["analiza", "raport", "slad"]
		},
		{
			"slug": "nationwide-e-waste-collection-network",
			"tag": "WEEE",
			"title": "A nationwide e-waste collection network",
			"challenge": "Scattered e-waste collection from residents with no single request channel and no data on outcomes.",
			"solution": "Red collection bins, bulky home collections and an education campaign for residents.",
			"outcome": "Requests accepted through the online form 24/7, with outcomes reported as indicators.",
			"stat": "24/7",
			"statLabel": "requests via the online form",
			"photo": "stoisko-tlum",
			"serviceIds": ["siec", "zwrotna", "edu"]
		}
	],
	"insights": [
		{
			"slug": "eu-battery-regulation-2023-1542",
			"tag": "Regulation",
			"title": "EU Battery Regulation 2023/1542 — what changes for producers",
			"excerpt": "New obligations on collection, the battery passport and recovery levels, in practical terms.",
			"readingMinutes": 7
		},
		{
			"slug": "deposit-scheme-in-practice-data-skus-settlement",
			"tag": "Deposit scheme",
			"title": "The deposit scheme in practice: data, SKUs and settlement",
			"excerpt": "How to prepare the product list and avoid the most common rollout mistakes.",
			"readingMinutes": 6
		},
		{
			"slug": "separate-textile-collection-a-model-for-municipalities",
			"tag": "Textiles",
			"title": "Separate textile collection — a model for municipalities",
			"excerpt": "From the collection point to the sorting plant: who owns which stage and how to measure the outcome.",
			"readingMinutes": 8
		},
		{
			"slug": "double-materiality-step-by-step",
			"tag": "ESG",
			"title": "Double materiality step by step",
			"excerpt": "How to run an analysis that passes assurance and does not take a year.",
			"readingMinutes": 9
		},
		{
			"slug": "li-ion-batteries-in-the-warehouse-fire-risk",
			"tag": "Safety",
			"title": "Li-ion batteries in the warehouse — how to cut the fire risk",
			"excerpt": "Containers, procedures, training and the emergency collection route.",
			"readingMinutes": 5
		},
		{
			"slug": "reuse-before-recycling-when-it-pays-off",
			"tag": "Circular economy",
			"title": "RE-USE before recycling — when it pays off",
			"excerpt": "The economics of the second loop for returns and warehouse surplus.",
			"readingMinutes": 6
		}
	],
	"pillars": [
		{
			"title": "Recycling and processing",
			"desc": "WEEE, battery, refrigeration and electronics plants."
		},
		{ "title": "Re-use", "desc": "Refurbishment, grading and multichannel sales." },
		{ "title": "Textiles", "desc": "Sorting facility, commercial fractions and export." },
		{ "title": "Collection and logistics", "desc": "ADR fleet, containers and point networks." },
		{
			"title": "Deposit scheme and EPR",
			"desc": "Operations, data and producer services."
		},
		{ "title": "ESG and education", "desc": "Reporting, advisory and community programmes." }
	],
	"magnets": [
		{
			"slug": "deposit-scheme-after-year-one",
			"kind": "Report",
			"tag": "Deposit scheme",
			"title": "The deposit scheme after year one — data and conclusions",
			"desc": "Real return rates, operating costs and the most common producer mistakes. 28 pages, data from the Polish market.",
			"meta": "PDF · 28 pages",
			"cta": "Download the report",
			"doneTitle": "Your material is on the way",
			"doneDesc": "We have e-mailed the download link to the address you provided."
		},
		{
			"slug": "epr-for-textiles-webinar",
			"kind": "Webinar",
			"tag": "EPR textiles",
			"title": "EPR for textiles: how to prepare before the deadline",
			"desc": "60 minutes with the sorting-plant team and our advisors — obligations, costs and a rollout timeline for your company.",
			"meta": "Recording · 60 min",
			"cta": "Watch the webinar",
			"doneTitle": "Recording access sent",
			"doneDesc": "We have e-mailed the webinar recording link to the address you provided."
		},
		{
			"slug": "zero-fire-incidents-case-study",
			"kind": "Case study",
			"tag": "Li-ion batteries",
			"title": "Zero fire incidents across 40 sites",
			"desc": "How a power-tool manufacturer organised battery collection — audit, containers, ADR collections and the results after 12 months.",
			"meta": "PDF · 9 pages",
			"cta": "Download the case study",
			"doneTitle": "Your material is on the way",
			"doneDesc": "We have e-mailed the case-study download link to the address you provided."
		}
	]
}
